import React, { useState, useEffect, useRef, useCallback } from 'react';
import './TermsAndConditions.css';

// --- SEO Helmet Wrapper ---
const Helmet = ({ children }) => {
  useEffect(() => {
    document.documentElement.setAttribute('lang', 'en');
    const titleEl = document.querySelector('title');
    const metaDescriptionEl = document.querySelector('meta[name="description"]');
    let newTitle = "Terms & Conditions | Nutrivio Medical Services Private Limited";
    let newDescription = "Terms and Conditions governing Medical College Establishment, Institutional Advisory, and Medical Faculty Solutions by Nutrivio Medical Services Private Limited.";

    React.Children.forEach(children, child => {
      if (child && child.type === 'title') newTitle = child.props.children;
      if (child && child.type === 'meta' && child.props.name === 'description') newDescription = child.props.content;
    });

    if (titleEl) titleEl.innerText = newTitle;
    if (metaDescriptionEl) metaDescriptionEl.setAttribute('content', newDescription);
  }, [children]);
  return null;
};

// --- Custom SVGs for Medical Institutional Advisory & Legal Clarity ---
const IconWrapper = ({ children, size = 20, style, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor" 
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ marginRight: '10px', verticalAlign: 'middle', flexShrink: 0, ...style }}
    className={className}
    aria-hidden="true"
  >
    {children}
  </svg>
);

const ICONS = {
  INTRODUCTION: <IconWrapper><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></IconWrapper>,
  DEFINITIONS: <IconWrapper><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path></IconWrapper>,
  ADVISORY_SCOPE: <IconWrapper><path d="M3 21h18"></path><path d="M5 21V7l8-4v18"></path><path d="M19 21V11l-6-4"></path><path d="M9 9h1"></path><path d="M9 13h1"></path><path d="M9 17h1"></path></IconWrapper>,
  FACULTY_RECRUITMENT: <IconWrapper><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M22 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></IconWrapper>,
  FACULTY_CANDIDATE: <IconWrapper><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></IconWrapper>,
  CLIENT_OBLIGATIONS: <IconWrapper><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></IconWrapper>,
  STATUTORY_DISCLAIMER: <IconWrapper><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></IconWrapper>,
  CONFIDENTIALITY: <IconWrapper><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></IconWrapper>,
  DATA_PROTECTION: <IconWrapper><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><path d="m9 12 2 2 4-4"></path></IconWrapper>,
  COMMERCIALS: <IconWrapper><rect x="2" y="4" width="20" height="16" rx="2"></rect><line x1="2" y1="10" x2="22" y2="10"></line></IconWrapper>,
  IP_RIGHTS: <IconWrapper><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06-.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></IconWrapper>,
  WARRANTY_LIABILITY: <IconWrapper><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></IconWrapper>,
  TERMINATION: <IconWrapper><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></IconWrapper>,
  DISPUTE_RESOLUTION: <IconWrapper><polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline></IconWrapper>,
  FORCE_MAJEURE: <IconWrapper><path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z"></path></IconWrapper>,
  CHANGES_TERMS: <IconWrapper><polyline points="23 4 23 10 17 10"></polyline><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path></IconWrapper>,
  CONTACT_INFO: <IconWrapper><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></IconWrapper>,
  ARROW_UP: <IconWrapper size={20} style={{marginRight: 0}}><line x1="12" y1="19" x2="12" y2="5"></line><polyline points="5 12 12 5 19 12"></polyline></IconWrapper>,
  SEARCH: <IconWrapper size={18} style={{marginRight: '8px'}} className="nutrivio-tnc-search-icon"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></IconWrapper>,
};

const lastUpdatedDate = "August 31, 2026";
const officialEmail = "nutrivioheadoffice@gmail.com";
const officialPhone = "+91 90383 20103";
const officialAddress = "Mani Casadona, IT/ITES Business Hub, New Town, Rajarhat, Kolkata, West Bengal – 700161, India";

// --- Nutrivio Master Content for Institutional Advisory & Medical Education ---
const rawSectionsData = [
  {
    id: 'introduction',
    title: '1. Introduction & Acceptance of Terms',
    icon: ICONS.INTRODUCTION,
    content: `
      <p>Welcome to <strong>Nutrivio Medical Services Private Limited</strong> ("Nutrivio," "Company," "we," "us," or "our"). These Terms and Conditions ("Terms") constitute a legally binding agreement between Nutrivio and any individual or entity accessing our website, utilising our advisory platforms, or engaging our professional services (collectively, the "Services").</p>
      <p>Nutrivio is a specialised <strong>Medical Education Institutional Advisory & Professional Services Company</strong> serving educational organisations, healthcare conglomerates, trusts, societies, universities, Medical Colleges, and Teaching Hospitals across India. Our core capabilities encompass New Medical College Establishment Advisory, MBBS Seat Expansion, New PG (MD/MS) Course Introductions, PG Seat Expansion, Institutional & Teaching Hospital Compliance Reviews, Documentation & Institutional Readiness, and Permanent & Full-Time Medical Faculty Solutions.</p>
      <p>By engaging our advisory services, requesting faculty recruitment support, registering a professional medical profile, or browsing our corporate website, you ("Client," "Institution," "Candidate," "User," or "you") confirm that you have read, understood, and agreed to be bound by these Terms, our Privacy Policy, and any executed formal Service Proposal or Agreement. If you disagree with any provision herein, you must immediately discontinue the use of our website and services.</p>
    `,
  },
  {
    id: 'definitions',
    title: '2. Definitions & Legal Interpretations',
    icon: ICONS.DEFINITIONS,
    content: `
      <p>Throughout these Terms, the following terms shall have the assigned meanings:</p>
      <ul>
        <li><strong>"Advisory Services"</strong> means the professional consultancy, gap assessment, infrastructural guidance, and documentation support provided by Nutrivio for medical education institutions.</li>
        <li><strong>"Affiliates"</strong> means any entity that directly or indirectly controls, is controlled by, or is under common control with Nutrivio.</li>
        <li><strong>"Candidate / Medical Faculty"</strong> refers to qualified medical professionals (pre-clinical, para-clinical, clinical, and allied super-specialists) submitting credentials to Nutrivio for academic placement.</li>
        <li><strong>"Competent Authority"</strong> means the National Medical Commission (NMC), Medical Assessment and Rating Board (MARB), Ministry of Health and Family Welfare (MoHFW), affiliating Health Universities, State Medical Councils, and any other relevant statutory bodies.</li>
        <li><strong>"Client / Institution"</strong> means any society, trust, hospital group, university, or promoter that engages Nutrivio under a formal proposal or contract.</li>
        <li><strong>"Confidential Information"</strong> refers to all proprietary data, institutional master plans, inspection dossiers, faculty rosters, candidate CVs, financial projections, and corporate data exchanged during the engagement.</li>
        <li><strong>"Proposal / SOW"</strong> refers to the formal Service Proposal or Statement of Work executed between Nutrivio and the Client outlining specific deliverables and commercial terms.</li>
      </ul>
    `,
  },
  {
    id: 'institutional-advisory-scope',
    title: '3. Scope of Institutional Advisory Services',
    icon: ICONS.ADVISORY_SCOPE,
    content: `
      <p>Nutrivio delivers structured advisory support across the complete lifecycle of medical education institutions:</p>
      <ul>
        <li><strong>New Medical College Establishment:</strong> Preliminary feasibility assessments, project roadmaps, intake sizing (50/100/150/250 seats), department-wise infrastructure planning, Teaching Hospital bed-strength & clinical material assessment, and application documentation coordination.</li>
        <li><strong>MBBS Seat Expansion:</strong> Eligibility analysis, hospital capacity assessment (OPD/IPD/occupancy), departmental readiness, clinical material reviews, and statutory application assistance for existing Medical Colleges.</li>
        <li><strong>PG (MD/MS) Course & Seat Expansion:</strong> Departmental gap assessment, faculty/senior resident ratio planning, unit structuring, and documentation support for starting or expanding postgraduate programmes.</li>
        <li><strong>Institutional & Teaching Hospital Compliance:</strong> Comprehensive review of clinical ecosystem readiness, OT/ICU metrics, diagnostic labs, blood banks, central library, skills lab, and physical infrastructure.</li>
        <li><strong>Documentation & Institutional Readiness:</strong> Systematic compilation, validation, and organisation of institutional records, faculty declarations, hospital statistics, and portal submissions.</li>
      </ul>
      <p>All advisory engagements are executed strictly according to the agreed written Proposal and scope of engagement.</p>
    `,
  },
  {
    id: 'faculty-recruitment-services',
    title: '4. Permanent & Full-Time Faculty Solutions',
    icon: ICONS.FACULTY_RECRUITMENT,
    content: `
      <p>Nutrivio provides dedicated academic recruitment solutions for Medical Colleges and Teaching Hospitals seeking qualified professionals for genuine <strong>Permanent & Full-Time</strong> appointments:</p>
      <ul>
        <li><strong>Departmental Coverage:</strong> Pre-Clinical (Anatomy, Physiology, Biochemistry), Para-Clinical (Pathology, Pharmacology, Microbiology, FMT, Community Medicine), and Clinical & Allied Specialities.</li>
        <li><strong>Academic Designations:</strong> Professors, Associate Professors, Assistant Professors, Senior Residents, and Tutors/Demonstrators.</li>
        <li><strong>Recruitment Workflow:</strong> Institutional requirement assessment, sourcing, credential pre-screening, qualification/experience review, interview coordination, selection facilitation, and onboarding documentation assistance.</li>
      </ul>
      <div class="nutrivio-tnc-callout-box">
        <p><strong>Recruitment Policy:</strong> Nutrivio supports genuine full-time academic appointments only. Nutrivio does not engage in or facilitate ghost faculty, temporary impersonation, or deceptive regulatory practices.</p>
      </div>
    `,
  },
  {
    id: 'faculty-candidate-provisions',
    title: '5. Medical Faculty Candidate Terms & CV Submissions',
    icon: ICONS.FACULTY_CANDIDATE,
    content: `
      <p>Medical professionals submitting credentials, CVs, or registration details through our website or recruitment channels agree to the following terms:</p>
      <ul>
        <li><strong>Accuracy of Credentials:</strong> The Candidate warrants that all qualifications, state/national medical registration numbers, degrees, teaching experience certificates, research publications, and employment history provided are authentic, true, and legally valid.</li>
        <li><strong>Consent for Profile Coordination:</strong> By submitting your profile, you grant Nutrivio permission to review, verify, and share your redacted or full professional profile with prospective Medical Colleges and Teaching Hospitals for academic appointments.</li>
        <li><strong>No Guarantee of Placement:</strong> Submission of a profile does not create an employment contract or guarantee interview shortlisting or appointment. Selection is solely at the discretion of the hiring institution.</li>
        <li><strong>Confidential Data Handling:</strong> Nutrivio maintains candidate resumes in a secure, non-public backend accessible only to authorised recruitment personnel. Candidate data is never sold to third-party marketing brokers.</li>
      </ul>
    `,
  },
  {
    id: 'client-responsibilities',
    title: '6. Client Institutional Responsibilities & Obligations',
    icon: ICONS.CLIENT_OBLIGATIONS,
    content: `
      <p>To ensure optimal execution of advisory deliverables and faculty placements, the Client agrees to:</p>
      <ul>
        <li><strong>Provision of Authentic Data:</strong> Provide authentic, updated, and accurate institutional data, clinical statistics, architectural layouts, and existing faculty records in a timely manner.</li>
        <li><strong>Designated Single Point of Contact (SPOC):</strong> Appoint an authorised representative with decision-making authority to coordinate with Nutrivio's advisory team.</li>
        <li><strong>Direct Verification & Onboarding:</strong> Verify original degree certificates, medical registrations, experience letters, and biometric requirements of candidates prior to issuing formal appointment orders.</li>
        <li><strong>Physical Infrastructure & Execution:</strong> Acknowledge that the physical development, financial investment, statutory fee payments, civil construction, hospital management, and equipment procurement remain the sole responsibility of the institution's management.</li>
      </ul>
    `,
  },
  {
    id: 'independent-advisory-disclaimer',
    title: '7. Independent Advisory & No Guaranteed Approval Disclaimer',
    icon: ICONS.STATUTORY_DISCLAIMER,
    content: `
      <div class="nutrivio-tnc-callout-box">
        <p><strong>IMPORTANT STATUTORY DISCLAIMER:</strong> Nutrivio Medical Services Private Limited operates as an independent professional advisory and management consultancy firm. We are not an affiliate, agent, or representative of the National Medical Commission (NMC), MARB, MoHFW, or any governmental regulatory authority.</p>
      </div>
      <p><strong>No Regulatory Approvals Guaranteed:</strong> Formal approvals, Letters of Intent (LoI), Letters of Permission (LoP), seat enhancements, or recognition decisions are issued exclusively at the sovereign discretion of the statutory bodies following their independent evaluation and assessment. Nutrivio does not guarantee, represent, or warrant that any application, inspection, or seat enhancement will be automatically approved.</p>
      <p>Nutrivio's role is strictly confined to professional guidance, requirement gap analysis, documentation preparation, and institutional preparedness support.</p>
    `,
  },
  {
    id: 'confidentiality',
    title: '8. Confidentiality & Non-Disclosure',
    icon: ICONS.CONFIDENTIALITY,
    content: `
      <p>Both Nutrivio and the Client agree to maintain the highest level of confidentiality regarding all proprietary information disclosed during the engagement:</p>
      <ul>
        <li><strong>Protection of Information:</strong> Neither party shall disclose the other party's Confidential Information to any third party without prior written consent, except to employees, consultants, and legal advisors bound by similar non-disclosure terms.</li>
        <li><strong>Exclusions:</strong> Confidentiality obligations do not apply to information that is publicly known through no breach of this agreement, was already known prior to receipt, or is required to be disclosed by statutory law or court order.</li>
        <li><strong>Survival:</strong> Confidentiality obligations shall survive the expiration or termination of the engagement for a minimum period of three (3) years.</li>
      </ul>
    `,
  },
  {
    id: 'data-protection',
    title: '9. Data Protection, Privacy & Secure CV Handling',
    icon: ICONS.DATA_PROTECTION,
    content: `
      <p>Nutrivio complies with applicable data protection laws, including the <em>Indian Information Technology Act, 2000</em>, the <em>Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011</em>, and the <em>Digital Personal Data Protection Act (DPDPA), 2023</em>.</p>
      <ul>
        <li><strong>Data Collection Purpose:</strong> Personal and professional information collected via enquiry forms, registration portals, and CV uploads is processed exclusively for institutional advisory communication and faculty recruitment coordination.</li>
        <li><strong>Security Standards:</strong> We enforce encrypted transmission (HTTPS/SSL), role-based administrator access controls, and protected cloud repositories to prevent unauthorised disclosure or indexing of sensitive CVs and doctor data.</li>
        <li><strong>Candidate Data Rights:</strong> Candidates retain the right to request review, correction, or deletion of their registered profile by contacting our compliance desk.</li>
      </ul>
    `,
  },
  {
    id: 'commercial-payment-terms',
    title: '10. Professional Fees, Invoicing & Commercial Terms',
    icon: ICONS.COMMERCIALS,
    content: `
      <p>The commercial terms, milestone schedules, and retainer fees for Advisory and Faculty Recruitment services are governed by the specific formal Proposal or Service Level Agreement executed with each Client:</p>
      <ul>
        <li><strong>Milestone-Based Invoicing:</strong> Advisory fees are invoiced upon completion of defined stages (e.g., gap assessment, documentation submission, readiness audit).</li>
        <li><strong>Recruitment Placement Fees:</strong> Faculty placement fees become payable upon candidate selection and joining, subject to the replacement guarantee terms stated in the service agreement.</li>
        <li><strong>Taxes:</strong> All professional fees are exclusive of applicable Goods and Services Tax (GST), which shall be charged additionally in accordance with prevailing Indian tax regulations.</li>
        <li><strong>Late Payments:</strong> Overdue invoices may attract interest or lead to a temporary pause in advisory support and candidate pipeline coordination until settled.</li>
      </ul>
    `,
  },
  {
    id: 'intellectual-property',
    title: '11. Intellectual Property Rights & Advisory Deliverables',
    icon: ICONS.IP_RIGHTS,
    content: `
      <p><strong>Nutrivio Pre-existing IP:</strong> All proprietary frameworks, gap assessment methodologies, documentation checklists, assessment templates, training materials, website source code, and branding remain the exclusive intellectual property of Nutrivio Medical Services Private Limited.</p>
      <p><strong>Custom Institutional Deliverables:</strong> Upon receipt of full and final payment for advisory services, the Client receives a non-exclusive license to utilise the tailored assessment reports, master documentation binders, and roadmaps developed specifically for their institution's regulatory and operational use.</p>
    `,
  },
  {
    id: 'warranties-and-liability',
    title: '12. Limitation of Liability & Warranties',
    icon: ICONS.WARRANTY_LIABILITY,
    content: `
      <p><strong>Service Standard:</strong> Nutrivio warrants that its advisory and recruitment services shall be executed with reasonable professional care, diligence, and industry expertise aligned with prevailing medical education guidelines.</p>
      <p><strong>Disclaimer of Indirect Damages:</strong> Under no circumstances shall Nutrivio, its directors, officers, or employees be liable for any indirect, consequential, special, punitive, or loss-of-profit damages arising out of regulatory delays, inspection outcomes, university affiliations, or candidate non-joining.</p>
      <p><strong>Liability Cap:</strong> The maximum aggregate liability of Nutrivio for any claims arising under or related to an engagement shall not exceed the actual advisory or recruitment fees received by Nutrivio under the specific SOW during the six (6) months preceding the claim.</p>
    `,
  },
  {
    id: 'termination',
    title: '13. Term, Suspension & Termination',
    icon: ICONS.TERMINATION,
    content: `
      <p><strong>Agreement Duration:</strong> These Terms remain in force while you access the website or during the active validity of a formal Service Agreement.</p>
      <ul>
        <li><strong>Termination for Convenience:</strong> Either party may terminate an advisory engagement by providing written notice as specified in the formal contract (typically 30 days).</li>
        <li><strong>Termination for Cause:</strong> Either party may terminate immediately if the other party commits a material breach, becomes insolvent, or engages in unlawful or fraudulent regulatory conduct.</li>
        <li><strong>Payment upon Termination:</strong> Upon termination, the Client shall pay Nutrivio for all advisory services rendered, milestones achieved, and non-cancellable expenses incurred up to the termination date.</li>
      </ul>
    `,
  },
  {
    id: 'dispute-resolution',
    title: '14. Dispute Resolution & Governing Jurisdiction (India)',
    icon: ICONS.DISPUTE_RESOLUTION,
    content: `
      <p>These Terms and any dispute or claim arising out of them shall be governed by and construed in accordance with the substantive laws of India.</p>
      <ul>
        <li><strong>Amicable Negotiation:</strong> The parties shall first attempt in good faith to resolve any dispute through direct senior-management consultation within twenty-one (21) business days.</li>
        <li><strong>Arbitration:</strong> If unresolved, the dispute shall be referred to and finally resolved by arbitration in accordance with the <em>Arbitration and Conciliation Act, 1996</em>. The arbitration tribunal shall consist of a sole arbitrator appointed by mutual consent. The arbitration proceedings shall be conducted in the English language.</li>
        <li><strong>Exclusive Jurisdiction:</strong> Subject to arbitration, the courts having territorial jurisdiction over Nutrivio's registered corporate office in Kolkata, West Bengal, India shall have exclusive jurisdiction over any legal proceedings.</li>
      </ul>
    `,
  },
  {
    id: 'force-majeure',
    title: '15. Force Majeure Clause',
    icon: ICONS.FORCE_MAJEURE,
    content: `
      <p>Neither party shall be held liable for failure or delay in performing contractual obligations (other than payment duties) caused by events beyond reasonable control, including but not limited to:</p>
      <ul>
        <li>Acts of God, natural calamities, epidemics, pandemics, or public health emergencies.</li>
        <li>Sudden statutory moratoriums, regulatory gazette amendments, court stay orders, or government-imposed shutdowns.</li>
        <li>War, civil unrest, regional telecommunication failures, or severe utility disruptions.</li>
      </ul>
      <p>The affected party shall promptly notify the other party and undertake all reasonable steps to resume performance as soon as practical.</p>
    `,
  },
  {
    id: 'changes-to-terms',
    title: '16. Amendments & Modifications',
    icon: ICONS.CHANGES_TERMS,
    content: `
      <p>Nutrivio reserves the right to revise and update these Terms and Conditions periodically to reflect modifications in regulatory norms, statutory legal amendments, or company operational policies.</p>
      <p>Updated versions will be posted on this website with a revised "Last Updated" date. Continued engagement with our advisory services or use of the website following such updates constitutes full acceptance of the revised Terms.</p>
    `,
  },
  {
    id: 'contact-statutory-info',
    title: '17. Contact & Official Communication',
    icon: ICONS.CONTACT_INFO,
    content: `
      <p>For any legal inquiries, institutional contract clarifications, or compliance questions regarding these Terms, please contact our corporate desk:</p>
      <p><strong>NUTRIVIO MEDICAL SERVICES PRIVATE LIMITED</strong></p>
      <address class="nutrivio-tnc-contact-address">
        <strong>Office Address:</strong><br>
        ${officialAddress}
      </address>
      <p><strong>Phone:</strong> <a href="tel:+919038320103" class="nutrivio-tnc-contact-link">${officialPhone}</a></p>
      <p><strong>WhatsApp:</strong> <a href="https://wa.me/919038320103" target="_blank" rel="noopener noreferrer" class="nutrivio-tnc-contact-link">${officialPhone}</a></p>
      <p><strong>Official Email:</strong> <a href="mailto:${officialEmail}" class="nutrivio-tnc-contact-link">${officialEmail}</a></p>
      <hr class="nutrivio-tnc-section-divider" />
      <p class="nutrivio-tnc-last-updated-text"><em>These Terms and Conditions were last reviewed and updated on: <strong>${lastUpdatedDate}</strong>. Copyright © 2026 Nutrivio Medical Services Private Limited. All Rights Reserved.</em></p>
    `,
  },
];

// Apply prefix to every section ID
const SECTIONS_DATA = rawSectionsData.map(section => ({
  ...section,
  id: `terms-and-conditions-${section.id}`,
}));

// --- Reusable Accordion Item ---
const AccordionItem = ({ id, title, icon, content, isOpen, onToggle, itemRef }) => {
  const contentRef = useRef(null);
  return (
    <div className="nutrivio-tnc-accordion-item" ref={itemRef}>
      <h3 className="nutrivio-tnc-accordion-header">
        <button
          id={`accordion-header-${id}`} 
          aria-expanded={isOpen}
          aria-controls={`accordion-content-${id}`} 
          onClick={onToggle}
          className="nutrivio-tnc-accordion-button"
        >
          <span className="nutrivio-tnc-accordion-title-content">
            {icon}
            {title}
          </span>
          <span className={`nutrivio-tnc-accordion-chevron ${isOpen ? 'nutrivio-tnc-open' : ''}`} aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
          </span>
        </button>
      </h3>
      <div
        ref={contentRef}
        id={`accordion-content-${id}`} 
        role="region"
        aria-labelledby={`accordion-header-${id}`} 
        className="nutrivio-tnc-accordion-content"
        style={{ maxHeight: isOpen && contentRef.current ? `${contentRef.current.scrollHeight}px` : '0px' }}
      >
        <div className="nutrivio-tnc-accordion-content-inner" dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </div>
  );
};

// --- Reusable Desktop Sidebar Item ---
const StickyNavItem = ({ section, isActive, onClick }) => (
  <li className={`nutrivio-tnc-sticky-nav-item ${isActive ? 'nutrivio-tnc-active' : ''}`}>
    <a 
      href={`#${section.id}`} 
      onClick={(e) => { e.preventDefault(); onClick(section.id); }} 
      className="nutrivio-tnc-sticky-nav-link"
    >
      {section.title}
    </a>
  </li>
);

// --- Back to Top Button ---
const BackToTopButton = ({ isVisible }) => (
  <button
    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    className={`nutrivio-tnc-back-to-top-button ${isVisible ? 'nutrivio-tnc-visible' : ''}`}
    aria-label="Back to top"
    title="Back to top"
  >
    {ICONS.ARROW_UP}
  </button>
);

// --- Responsive Breadcrumbs ---
const Breadcrumbs = () => (
  <nav aria-label="Breadcrumb" className="nutrivio-tnc-breadcrumbs">
    <ol>
      <li><a href="/">Home</a></li>
      <li><span className="nutrivio-tnc-breadcrumb-separator" aria-hidden="true">›</span><span aria-current="page">Terms & Conditions</span></li>
    </ol>
  </nav>
);

// --- Device Width Hook ---
const useIsMobile = (breakpoint = 1024) => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < breakpoint);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);
  return isMobile;
};

// --- Main Page Component ---
const TermsAndConditions = () => {
  const [openSections, setOpenSections] = useState([]);
  const [activeTocId, setActiveTocId] = useState(null);
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileSelectedId, setMobileSelectedId] = useState('all');
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  
  const isMobile = useIsMobile();
  const sectionRefs = useRef({});
  const mobileNavRef = useRef(null);
  
  SECTIONS_DATA.forEach(section => {
    if (!sectionRefs.current[section.id]) {
      sectionRefs.current[section.id] = React.createRef();
    }
  });

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const subheaderElement = document.querySelector(`.nutrivio-tnc-page-subheader`);
      const subheaderHeight = subheaderElement ? subheaderElement.offsetHeight : 55;
      const offset = subheaderHeight + 110;

      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
    }
  };

  const toggleSection = (id) => {
    setOpenSections(prevOpen => 
      prevOpen.includes(id) ? prevOpen.filter(sid => sid !== id) : [...prevOpen, id]
    );
  };
  
  const handleTocClick = (id) => { 
    if (!openSections.includes(id)) {
      setOpenSections(prev => [...prev, id]);
    }
    setActiveTocId(id);
    scrollToSection(id);
  };

  const handleMobileNavItemClick = (sectionId) => {
    setMobileSelectedId(sectionId);
    setActiveTocId(sectionId === 'all' ? SECTIONS_DATA[0].id : sectionId);

    if (sectionId === 'all') {
      setOpenSections([SECTIONS_DATA[0].id]);
      scrollToSection(SECTIONS_DATA[0].id);
    } else {
      setOpenSections([sectionId]);
      scrollToSection(sectionId);
    }
    setIsMobileNavOpen(false);
  };
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobileNavOpen && mobileNavRef.current && !mobileNavRef.current.contains(event.target)) {
        setIsMobileNavOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMobileNavOpen]);

  const handleScroll = useCallback(() => { 
    setShowBackToTop(window.scrollY > 350);

    let currentActiveId = null;
    const subheaderElement = document.querySelector(`.nutrivio-tnc-page-subheader`);
    const subheaderHeight = subheaderElement ? subheaderElement.offsetHeight : 55;
    const headerOffset = subheaderHeight + 115; 
    
    const sectionsInView = (isMobile && mobileSelectedId !== 'all') 
      ? SECTIONS_DATA.filter(s => s.id === mobileSelectedId)
      : SECTIONS_DATA.filter(s => s.title.toLowerCase().includes(searchTerm.toLowerCase()));

    for (let i = sectionsInView.length - 1; i >= 0; i--) {
      const section = sectionsInView[i];
      const element = document.getElementById(section.id);
      if (element) {
        const rect = element.getBoundingClientRect();
        if (rect.top <= headerOffset) {
          currentActiveId = section.id;
          break;
        }
      }
    }
    
    if (mobileSelectedId !== 'all') {
      setActiveTocId(mobileSelectedId);
    } else {
      if (!currentActiveId && sectionsInView.length > 0) {
        currentActiveId = sectionsInView[0].id;
      }
      setActiveTocId(currentActiveId);
    }
  }, [searchTerm, isMobile, mobileSelectedId]); 

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    const firstSectionId = SECTIONS_DATA.length > 0 ? SECTIONS_DATA[0].id : null;
    if (firstSectionId) {
      setOpenSections([firstSectionId]);
      setActiveTocId(firstSectionId);
    }

    const idFromHash = window.location.hash.substring(1);
    if (idFromHash && SECTIONS_DATA.find(s => s.id === idFromHash)) {
      setTimeout(() => handleTocClick(idFromHash), 100);
    }
    
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const searchFilteredSections = SECTIONS_DATA.filter(section => 
    section.title.toLowerCase().includes(searchTerm.toLowerCase())
  );
  
  const sectionsToRender = (isMobile && mobileSelectedId !== 'all')
    ? searchFilteredSections.filter(s => s.id === mobileSelectedId)
    : searchFilteredSections;

  const pageTitle = "Terms & Conditions | Nutrivio Medical Services Private Limited";
  const pageDescription = "Official Terms and Conditions for Nutrivio Medical Services Private Limited, governing Medical College Establishment Advisory, Institutional Readiness, and Medical Faculty Solutions across India.";

  const selectedTitle = mobileSelectedId === 'all'
    ? 'Show All Sections'
    : searchFilteredSections.find(s => s.id === mobileSelectedId)?.title || 'Select a section...';

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://nutriviomedical.com/terms-and-conditions" />
        <meta name="keywords" content="Nutrivio Medical Services terms, medical college establishment advisory terms, medical faculty recruitment agreement India, MBBS expansion consultancy disclaimer, institutional compliance legal terms" />
        <link rel="canonical" href="https://nutriviomedical.com/terms-and-conditions" />
      </Helmet>

      <div className="nutrivio-tnc-page-container">
        
        {/* Sticky Subheader & Breadcrumbs Only (No Top Hero Banner) */}
        <div className="nutrivio-tnc-page-subheader">
          <div className="nutrivio-tnc-subheader-left">
            <Breadcrumbs />
            <div className="nutrivio-tnc-mobile-header-content">
              <a href="/">Home</a>
              <span className="nutrivio-tnc-mobile-header-separator" aria-hidden="true">›</span>
              <span aria-current="page">Terms & Conditions</span>
            </div>
          </div>
        </div>

        <div className="nutrivio-tnc-main-layout">
          
          {/* Sidebar Navigation Area */}
          <aside className="nutrivio-tnc-sticky-nav-container">
            <div className="nutrivio-tnc-search-bar-container">
              <div className="nutrivio-tnc-search-input-wrapper">
                {ICONS.SEARCH}
                <input
                  type="search"
                  placeholder="Search legal sections..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="nutrivio-tnc-search-input"
                  aria-label="Filter terms sections by title"
                />
              </div>
            </div>
            
            {/* Custom Dropdown for Mobile */}
            <div className="nutrivio-tnc-mobile-nav-dropdown-wrapper" ref={mobileNavRef}>
              <label htmlFor="nutrivio-tnc-mobile-nav-toggle" className="nutrivio-tnc-sticky-nav-title" style={{ display: 'block', paddingLeft: 0 }}>
                Table of Contents
              </label>
              <button
                id="nutrivio-tnc-mobile-nav-toggle"
                className="nutrivio-tnc-mobile-nav-toggle-button"
                onClick={() => setIsMobileNavOpen(!isMobileNavOpen)}
                aria-haspopup="listbox"
                aria-expanded={isMobileNavOpen}
              >
                <span>{selectedTitle}</span>
                <span className={`nutrivio-tnc-mobile-select-chevron ${isMobileNavOpen ? 'nutrivio-tnc-open' : ''}`} aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
                </span>
              </button>
              {isMobileNavOpen && (
                <ul className="nutrivio-tnc-mobile-nav-listbox" role="listbox">
                  <li
                    className={mobileSelectedId === 'all' ? 'nutrivio-tnc-active' : ''}
                    onClick={() => handleMobileNavItemClick('all')}
                    role="option"
                    aria-selected={mobileSelectedId === 'all'}
                  >
                    Show All Sections
                  </li>
                  {searchFilteredSections.map(section => (
                    <li
                      key={section.id}
                      className={mobileSelectedId === section.id ? 'nutrivio-tnc-active' : ''}
                      onClick={() => handleMobileNavItemClick(section.id)}
                      role="option"
                      aria-selected={mobileSelectedId === section.id}
                    >
                      {section.title}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            {/* Desktop Navigation Table of Contents */}
            <nav aria-label="Table of contents" className="nutrivio-tnc-desktop-nav">
              <h2 className="nutrivio-tnc-sticky-nav-title">Table of Contents</h2>
              {searchFilteredSections.length > 0 ? (
                <ul className="nutrivio-tnc-sticky-nav-list">
                  {searchFilteredSections.map(section => (
                    <StickyNavItem
                      key={section.id}
                      section={section}
                      isActive={activeTocId === section.id}
                      onClick={handleTocClick}
                    />
                  ))}
                </ul>
              ) : (
                <p className="nutrivio-tnc-no-results-message">No sections match your filter.</p>
              )}
            </nav>
          </aside>

          {/* Main Content Sections */}
          <main className="nutrivio-tnc-main-content" role="main" id="nutrivio-tnc-main-content">
            {sectionsToRender.length > 0 ? (
              sectionsToRender.map(section => (
                <div 
                  key={section.id} 
                  id={section.id} 
                  ref={sectionRefs.current[section.id]} 
                  className="nutrivio-tnc-content-section" 
                  aria-labelledby={`accordion-header-${section.id}`}
                >
                  <AccordionItem
                    id={section.id}
                    title={section.title}
                    icon={section.icon}
                    content={section.content}
                    isOpen={openSections.includes(section.id)}
                    onToggle={() => toggleSection(section.id)}
                    itemRef={sectionRefs.current[section.id]}
                  />
                </div>
              ))
            ) : (
              <div className="nutrivio-tnc-no-content-message">
                <h3>No Matching Sections</h3>
                <p>No terms and conditions sections match your filter: "<strong>{searchTerm}</strong>".</p>
                <p>Please clear your search query or browse the complete table of contents.</p>
              </div>
            )}
          </main>

        </div>
      </div>

      <BackToTopButton isVisible={showBackToTop} />
    </>
  );
};

export default TermsAndConditions;